import { render, staticRenderFns } from "./complete_free.vue?vue&type=template&id=3b30df40&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b30df40')) {
      api.createRecord('3b30df40', component.options)
    } else {
      api.reload('3b30df40', component.options)
    }
    module.hot.accept("./complete_free.vue?vue&type=template&id=3b30df40&lang=pug&", function () {
      api.rerender('3b30df40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register_user/complete_free.vue"
export default component.exports